
<div style="height:100%;display: flex;align-items: center;justify-content: center;
font-family:'Inter';background-color:#fafafa;text-align: center;">
    <div>
        <!-- <h1 style="font-weight: bold;font-size:70px;">404</h1> -->
        <h1><i class="pi pi-exclamation-triangle" style="font-size:10rem; color: #a9a9a9"></i></h1>
        <p style="color:#0000008c;font-size:16px;">Oops... You do not have the permission to access this page</p>
        <!-- <button routerLink="" routerLinkActive="active" pButton pRipple label="Go Back" class="addButton"> 
            <i class="pi pi-arrow-left" style="font-size: 0.8em; padding-left:15px"></i>
        </button> -->
    </div>
</div>